import React, { useState } from 'react';
import classnames from 'classnames';
import './index.scss';
import { browser } from '../../utils/';
import SvgIcon from '../../images/svg/index';

export default function Header({style, entryAr, onAr, hide, onHide, onAppointment, isInterior, onIsInterior}) {
  const [ tipText, setTipText ] = useState(null);
  return (
    <div 
      className="header-root" 
      style={{...style}}
    >
      <button 
        style={{visibility: (isInterior || hide) ? 'hidden' : 'inherit'}}
        className="header-btn ar-btn" onClick={() => {
          if (!browser('overios11')) {
            setTipText('因ios系统限制，该系统不支持AR模式，请升级至ios11及以上。');
          } else if (!browser('safari')) {
            setTipText('ios11及以上用户，请在Safari浏览器中打开使用AR模式。');
          } else {
            setTipText(null);
            onAr();
          }
        }}>
          <span className="shadow-box"></span>
          <span className="inner">
            {entryAr ? <span>
              <i className="icon-font">{'\ue612'}</i> 退出
            </span> : 'AR看车'}
          </span>
      </button>

      {!entryAr &&
      <button 
        className="hide-btn" 
        onClick={onHide}
      >
        <span className="shadow-box"></span>
        <span className="inner">
          <span className="svg-icon"><SvgIcon icon={ hide ? 'show' : 'hide' }></SvgIcon></span>
          <span className="text">
            { hide ? '显示' : '隐藏' }
          </span>
        </span>
      </button>}

      {!entryAr &&
      <button 
        style={{visibility: hide ? 'hidden' : 'inherit'}}
        className="header-btn appointment-btn" 
        onClick={onAppointment}
      >
        <span className="shadow-box"></span>
          <span className="inner">
          <span className="svg-icon"><SvgIcon icon="appointment"></SvgIcon></span>
          预约试驾
        </span>
      </button>}
      {!entryAr && !hide &&
      <div 
        className="interior-header"
        style={{backgroundImage: `url(
          ${isInterior ?
            require('../../images/exterior.jpg') :
            require('../../images/interior1.jpg')
          }
        )`}}
        onClick={onIsInterior}
      >
        <div className={classnames("mask", { isInterior })}></div>
        <p> 
          { isInterior ? '外观' : '内饰' } 
        </p>
      </div>}
      {tipText && 
      <div className="tips-layer" onClick={() => setTipText(null)}>
        <p> { tipText } </p>
      </div>}
    </div>
  )
}